<br><br>
<app-banner-app [retroSelected]="false"></app-banner-app>

<div style="background-color: #DFEAFF;">
    <br><br><br><br>
    <div class="container">
        <div class="row contenido">
            <div class="col">
                <div>
                    <span class="mobile-img">
                        <img class="image-size" src="./assets/img/FeedBackManos.png" />
                    </span>
                    <div class="texto">
                        <h3 class="texto2">
                            <span class="desktop-text">Ya tenemos tus datos</span>
                            <span class="mobile-text">¡Ya tenemos tus datos!</span>
                        </h3>
                        <h5 class="texto1">Nos pondremos en contacto contigo para continuar con el proceso.</h5>
                    </div>
                </div>
                <span class="desktop-img">
                    <img class="image-size" src="./assets/img/FeedBackManos.png" />
                </span>
                <br>

                <div class="container tamanioBoton">
                    <button class=" btn btn-primaryw-100 py-2 mb-lg-5 botonContinuar" (click)="volverIncio()"
                        type="submit">Volver
                        al inicio</button>
                </div>
            </div>
        </div>
    </div>
    <br><br>
</div>
<app-footer-app></app-footer-app>